const VISIBILITY_OPTIONS = {
  FULLY_VISIBLE: 'fullyVisible',
  PARTIALLY_VISIBLE: 'partiallyVisible',
  FULLY_HIDDEN: 'fullyHidden'
}
const VISIBILITY_LABELS = {
  fullyVisible: 'Fully visible',
  partiallyVisible: 'Partially visible',
  fullyHidden: 'Fully hidden'
}

export { VISIBILITY_OPTIONS, VISIBILITY_LABELS }
